import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p495331454970048512',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
